import React, { useState } from "react";
import { MAX_POST_LENGTH } from "../utils/limits";

const PostForm = ({ onPostCreated }) => {
  const [content, setContent] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!content.trim()) {
      setError("Post content cannot be empty");
      return;
    }

    try {
      const res = await fetch("/api/posts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // No username: the server takes the author from the session cookie.
        body: JSON.stringify({ content }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Failed to create post");
      }

      setContent("");
      onPostCreated(); // refresh feed
    } catch (err) {
      console.error("Error posting:", err);
      setError(err.message);
    }
  };

  return (
    <div className="post-form">
      <form onSubmit={handleSubmit}>
        {error && <p className="error-text">{error}</p>}

        <textarea
          placeholder="Share your lottery numbers, strategy, or thoughts..."
          maxLength={MAX_POST_LENGTH}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />

        <div className="post-form-actions">
          <button type="submit">Post</button>
          {content.length > MAX_POST_LENGTH - 200 && (
            <span className="char-count">
              {content.length}/{MAX_POST_LENGTH}
            </span>
          )}
        </div>
      </form>
    </div>
  );
};

export default PostForm;

